import React from 'react';
import AttachmentInputBase from './AttachmentInputBase';

const DEFAULT_IMAGE_ACCEPT = {
  'image/*': ['.jpeg', '.jpg', '.png', '.gif', '.webp', '.bmp', '.svg']
};

const ImageInput = (props) => (
  <AttachmentInputBase
    {...props}
    accept={props.accept ?? DEFAULT_IMAGE_ACCEPT}
    baseUrl="rest/image/"
    previewType="image"
    resourceFieldName="image"
    singleItemLabel="image"
    multipleItemLabel="images"
  />
);

export default ImageInput;
